/* ==================== CARRITO ====================
   Cajon lateral en vez de la pagina /cart: quien agrega algo no pierde el punto
   del scroll donde iba, y la compra pierde un paso completo.

   Vive aparte porque lo usan el home y la pagina del club. Se pinta solo: la
   pagina nada mas necesita un boton con id="clnavCart" en su barra.

   Habla con la Cart AJAX API de Shopify. Fuera de Shopify (preview local) esos
   endpoints no existen y se cae a un carrito en memoria para revisar el diseno.

   ---- por que el carrito decide la suscripcion y no solo el producto ----
   La pagina de producto ya ofrece suscribirse, pero mucha gente llega al cajon
   con todo suelto. Aqui es donde ya decidio que se lo lleva, y es el unico lugar
   donde ve el total: es el momento con menos friccion para cambiar de modalidad.
   Por eso cada linea trae su propio interruptor en vez de un boton global. */
(function(){
'use strict';

/* IDs reales de la tienda */
const VAR={
  '400'  :{original:42110569644101, cacao:42110569676869, vainilla:42110569709637,
           coco:null,               caramelo:42110569775173},
  '1l'   :42182029082693,
  shots  :42182021152837,
  molido :42193856987205
};
const INFO={
  '400'  :{n:'Cold Brew 400ml',   p:11000},
  '1l'   :{n:'Cold Brew 1 Litro', p:22000},
  shots  :{n:'Shot de Cold Brew', p:2900},
  molido :{n:'Café Molido 250g',  p:12500}
};
const NOMBRE={original:'Original',cacao:'Cacao',vainilla:'Vainilla',coco:'Coco',caramelo:'Caramelo'};
/* Dos umbrales, porque son DOS perfiles de envio distintos:
   - compra unica -> perfil general de Shopify, gratis desde $550
   - suscripcion  -> delivery profile que administra Seal, gratis desde $450
   Los dos se miden sobre el subtotal YA descontado, que es justo lo que suma
   `total` mas abajo (x.price ya viene con el plan aplicado). */
const ENVIO_GRATIS=55000;                       /* centavos: $550 */
const ENVIO_GRATIS_SUB=45000;                   /* centavos: $450 */
const pesos=c=>'$'+(c/100).toLocaleString('es-MX',{maximumFractionDigits:0});

/* ---- planes de Seal ----
   Los cuatro productos comparten los mismos tres planes, todos al 10%.
   Verificado contra /products/<handle>.js el 10 sep 2026. Si algun dia un
   producto deja de traerlos, se cae solo al modo compra unica: ELEGIBLES es
   la unica lista que hay que tocar. */
const PLANES=[
  {id:1511227461, n:'Cada semana',    corto:'semanal'},
  {id:1511260229, n:'Cada 2 semanas', corto:'quincenal'},
  {id:1511292997, n:'Cada mes',       corto:'mensual'}
];
const PLAN_DEFAULT=1511292997;                  /* mensual: el que menos compromete */
const DESC=0.10;
const ELEGIBLES=new Set(['cold-brew','cold-brew-coffee-1-litro','shot-cold-brew','cafe-molido-250gr']);
const planPorId=id=>PLANES.find(p=>p.id===+id);
const TERMS='/pages/terminos-y-condiciones#suscripciones';

/* ---- el cajon se inyecta solo, para no repetirlo en cada pagina ----
   Va DENTRO de .cl-home cuando existe: en Shopify todo nuestro CSS esta
   encerrado bajo esa clase, y colgado del <body> el cajon sale sin una sola
   regla aplicada (aparece como bloque suelto debajo del footer). */
const RAIZ=document.querySelector('.cl-home')||document.body;
RAIZ.insertAdjacentHTML('beforeend',`
<div class="clc-velo" id="clcVelo" aria-hidden="true"></div>
<aside class="clcart" id="clcart" role="dialog" aria-modal="true" aria-label="Tu carrito" aria-hidden="true">
  <div class="clc-top">
    <h3>Tu carrito</h3>
    <button class="clc-x" id="clcX" aria-label="Cerrar carrito">&times;</button>
  </div>
  <div class="clc-ahorro" id="clcAhorro" hidden></div>
  <div class="clc-body" id="clcBody"></div>
  <div class="clc-extras" id="clcExtras" hidden></div>
  <div class="clc-pie">
    <div class="clc-sum"><span>Subtotal</span><b id="clcSum">$0</b></div>
    <p class="clc-envio" id="clcEnvio">La caja de 5 llega gratis.</p>
    <label class="clc-consent" id="clcConsent" hidden>
      <input type="checkbox" id="clcOk">
      <span class="clc-consent-t" id="clcOkTxt"></span>
    </label>
    <button class="cl-btn clc-go" id="clcGo">Ir a pagar</button>
    <button class="clc-alt" id="clcAlt" hidden></button>
    <ul class="clc-sellos">
      <li>Sin plazo forzoso</li>
      <li>Cancelas en un clic</li>
      <li>La caja de 5 llega gratis</li>
    </ul>
    <button class="clc-seguir" id="clcSeguir">Seguir comprando</button>
  </div>
</aside>`);

const $=s=>document.getElementById(s);
const cajon=$('clcart'), velo=$('clcVelo'), cuerpo=$('clcBody'),
      suma=$('clcSum'), envio=$('clcEnvio'), boton=$('clnavCart'), cuenta=$('clnavN'),
      ahorroBar=$('clcAhorro'), extras=$('clcExtras'), consent=$('clcConsent'),
      okBox=$('clcOk'), okTxt=$('clcOkTxt'), irPagar=$('clcGo'), alterna=$('clcAlt');

let LOCAL=null;                                 /* solo se llena si no hay Shopify */
let ULTIMO={items:[]};                          /* ultimo carrito pintado */

async function pide(url, body){
  try{
    const r=await fetch(url, body?{method:'POST',headers:{'Content-Type':'application/json'},
                                   body:JSON.stringify(body)}:undefined);
    if(!r.ok) throw 0;
    const j=await r.json();
    if(!j || (!('items' in j) && !('item_count' in j))) throw 0;
    return j;
  }catch(e){ if(LOCAL===null) LOCAL={items:[]}; return null; }
}

/* la foto de cada linea sale del DOM, asi no hay rutas nuevas que portar */
function foto(sku, sabor){
  const img=document.querySelector(sku==='400'
    ? `.fcard[data-flavor="${sabor}"] img, .pcard[data-sku="400"] img`
    : `.pcard[data-sku="${sku}"] img, .role[data-a="${sku}"] img`);
  return img?img.src:'';
}

const carrito=async()=> (await pide('/cart.js')) || LOCAL || {items:[]};

async function agrega(sku, sabor, plan){
  const id = sku==='400' ? VAR['400'][sabor] : VAR[sku];
  if(!id) return false;                         /* sabor que todavia no se vende */
  const linea={id, quantity:1}; if(plan) linea.selling_plan=plan;
  const j=await pide('/cart/add.js',{items:[linea]});
  if(!j){                                        /* preview local */
    const clave=String(id), hay=LOCAL.items.find(x=>x.key===clave);
    if(hay) hay.quantity++;
    else LOCAL.items.push({key:clave, quantity:1, price:INFO[sku].p, original_price:INFO[sku].p,
      product_title:INFO[sku].n, handle:'cold-brew', variant_id:id,
      variant_title: sku==='400' ? NOMBRE[sabor] : null,
      image:foto(sku,sabor)});
  }
  return true;
}

async function cambia(key, qty){
  const j=await pide('/cart/change.js',{id:key, quantity:qty});
  if(!j){
    const i=LOCAL.items.findIndex(x=>x.key===key);
    if(i>-1){ if(qty<=0) LOCAL.items.splice(i,1); else LOCAL.items[i].quantity=qty; }
  }
}

/* ---- cambiar de modalidad una linea ----
   /cart/change.js acepta selling_plan, pero no en todas las versiones se lo
   traga para QUITARLO. Por eso se verifica contra el carrito que regresa y,
   si no aterrizo, se hace a la mala: borrar la linea y volverla a agregar.
   La linea se va al final, que es feo pero es mejor que un boton que no hace
   nada. */
async function modalidad(linea, planId){
  const key=linea.key, qty=linea.quantity, vid=linea.variant_id||linea.id;
  const cuerpoReq={id:key, quantity:qty};
  cuerpoReq.selling_plan = planId ? +planId : '';
  const j=await pide('/cart/change.js', cuerpoReq);
  if(j){
    const nueva=(j.items||[]).find(x=>String(x.variant_id||x.id)===String(vid));
    const aplicado=nueva && nueva.selling_plan_allocation
      ? nueva.selling_plan_allocation.selling_plan.id : null;
    if(String(aplicado||'')===String(planId||'')) return j;
    /* no aterrizo: a la mala */
    await pide('/cart/change.js',{id:key, quantity:0});
    const l={id:+vid, quantity:qty}; if(planId) l.selling_plan=+planId;
    return await pide('/cart/add.js',{items:[l]});
  }
  /* preview local */
  const it=LOCAL.items.find(x=>x.key===key);
  if(it){
    if(planId){ const p=planPorId(planId);
      it.selling_plan_allocation={selling_plan:{id:+planId, name:p?p.n:'Suscripción'}};
      it.price=Math.round(it.original_price*(1-DESC));
    } else { delete it.selling_plan_allocation; it.price=it.original_price; }
  }
  return null;
}

/* ---- cuentas del cajon ---- */
function calcula(c){
  const items=c.items||[];
  let total=0, n=0, ahorrando=0, ahorrable=0, subs=[], sueltasEleg=0;
  items.forEach(x=>{
    /* OJO: con plan de venta, original_price ya viene descontado (9900, no 11000).
       El precio de lista de verdad esta en la asignacion del plan. Verificado
       contra /cart.js el 10 sep 2026. */
    const alloc=x.selling_plan_allocation;
    const lista=(alloc&&alloc.compare_at_price)||x.original_price||x.price;
    const orig=lista*x.quantity;
    total+=x.price*x.quantity; n+=x.quantity;
    const plan=alloc?alloc.selling_plan:null;
    if(plan){ ahorrando+=orig-x.price*x.quantity; subs.push({...x, plan}); }
    else if(ELEGIBLES.has(x.handle)){ ahorrable+=Math.round(orig*DESC); sueltasEleg++; }
  });
  return {items,total,n,ahorrando,ahorrable,subs,sueltasEleg};
}

/* ---- el texto que el cliente acepta ----
   Tiene que decir monto y periodicidad, que es lo que exige el art 76 Bis.
   Si hay varias frecuencias mezcladas se enumeran, porque un solo monto
   mensual seria mentira. */
function consentTexto(r){
  const porPlan={};
  r.subs.forEach(s=>{ const k=s.plan.id;
    porPlan[k]=porPlan[k]||{n:planPorId(k)?planPorId(k).n.toLowerCase():s.plan.name.toLowerCase(), t:0};
    porPlan[k].t+=s.price*s.quantity; });
  const trozos=Object.values(porPlan).map(p=>`${pesos(p.t)} ${p.n}`);
  const lista = trozos.length===1 ? trozos[0]
    : trozos.slice(0,-1).join(', ')+' y '+trozos.slice(-1);
  return `Autorizo que Cabra Loca haga cargos automáticos de ${lista} a mi método de pago `
       + `hasta que yo cancele. Me avisarán por correo al menos 7 días antes de cada cargo y `
       + `puedo cancelar en cualquier momento, sin penalización, desde mi cuenta o desde el `
       + `enlace de cada aviso. Acepto los Términos de la suscripción.`;
}

/* la constancia viaja al pedido y de ahi a la suscripcion de Seal */
async function guardaConstancia(txt){
  await pide('/cart/update.js',{attributes:{
    'Consentimiento suscripcion': txt||'',
    'Consentimiento fecha': txt? new Date().toISOString() : ''
  }});
}

function lineaHTML(x){
  const plan=x.selling_plan_allocation?x.selling_plan_allocation.selling_plan:null;
  const eleg=ELEGIBLES.has(x.handle);
  const alloc=x.selling_plan_allocation;
  const lista=(alloc&&alloc.compare_at_price)||x.original_price||x.price;
  const orig=lista*x.quantity, real=x.price*x.quantity;
  const precio = plan && orig>real
    ? `<s>${pesos(orig)}</s> ${pesos(real)}`
    : pesos(real);
  const modo = !eleg ? '' : `
      <span class="clc-modo" role="group" aria-label="Modalidad">
        <button data-modo="una" aria-pressed="${!plan}">Una vez</button>
        <button data-modo="sub" aria-pressed="${!!plan}">Cada entrega <em>−10%</em></button>
      </span>
      ${plan?`<select class="clc-frec" aria-label="Cada cuándo">${
        PLANES.map(p=>`<option value="${p.id}"${p.id===plan.id?' selected':''}>${p.n}</option>`).join('')
      }</select>`:''}`;
  return `<div class="clc-linea${plan?' es-sub':''}" data-key="${x.key}" data-var="${x.variant_id||x.id}">
        <span class="clc-foto">${x.image?`<img src="${x.image}" alt="">`:''}</span>
        <span class="clc-info">
          <span class="clc-nom">${x.product_title}</span>
          ${x.variant_title&&x.variant_title!=='Default Title'?`<span class="clc-var">${x.variant_title}</span>`:''}
          ${modo}
          <span class="clc-fila">
            <span class="clc-qty">
              <button data-mas="-1" aria-label="Quitar uno">&minus;</button>
              <span>${x.quantity}</span>
              <button data-mas="1" aria-label="Agregar uno">+</button>
            </span>
            <span class="clc-precio">${precio}</span>
          </span>
        </span>
      </div>`;
}

/* ---- complementos ----
   Solo se ofrece lo que NO esta ya en el carrito. Un carrusel que te ofrece
   lo que acabas de meter se siente roto. */
function extrasHTML(c){
  const dentro=new Set((c.items||[]).map(x=>String(x.variant_id||x.id)));
  const cand=[
    {sku:'1l',     id:VAR['1l'],   n:'Cold Brew 1 Litro', p:22000},
    {sku:'shots',  id:VAR.shots,   n:'Shot de Cold Brew', p:2900},
    {sku:'molido', id:VAR.molido,  n:'Café Molido 250g',  p:12500}
  ].filter(x=>!dentro.has(String(x.id)));
  if(!cand.length) return '';
  return `<div class="clc-extras-h">Completa tu ritual</div>
    <div class="clc-extras-row">${cand.map(x=>`
      <button class="clc-extra" data-sku="${x.sku}">
        <span class="clc-extra-n">${x.n}</span>
        <span class="clc-extra-p">${pesos(x.p)}</span>
        <span class="clc-extra-mas">Agregar</span>
      </button>`).join('')}</div>`;
}

function pinta(c){
  ULTIMO=c;
  const r=calcula(c);
  if(cuenta) cuenta.textContent=r.n;
  if(boton) boton.toggleAttribute('data-vacio', r.n===0);
  suma.textContent=pesos(r.total);

  /* El envio se evalua por PERFIL, no sobre el carrito entero: lo suscrito va al
     perfil de Seal (gratis desde $450) y lo de compra unica al perfil general de
     Shopify (gratis desde $550). Por eso se separan los dos subtotales. En un
     carrito mixto Shopify cobra envio dividido y cualquier numero que pusieramos
     aqui seria una adivinanza, asi que ahi no se promete nada. */
  const totSub = r.subs.reduce((a,x)=>a+x.price*x.quantity, 0);
  const totUna = r.total - totSub;
  let msgEnvio;
  if (r.n===0) {
    msgEnvio = 'La caja de 5 llega gratis.';
  } else if (totSub>0 && totUna>0) {
    msgEnvio = 'El envío se calcula en el checkout.';
  } else {
    const esSub  = totSub>0;
    const umbral = esSub ? ENVIO_GRATIS_SUB : ENVIO_GRATIS;
    const falta  = umbral - (esSub ? totSub : totUna);
    msgEnvio = falta>0 ? `Te faltan <b>${pesos(falta)}</b> para el envío gratis.`
                       : '<b>Envío gratis</b> incluido.';
  }
  envio.innerHTML = msgEnvio;

  /* barra de ahorro: primero lo que dejas ir, luego lo que ya ganaste */
  if(r.ahorrable>0){
    ahorroBar.hidden=false; ahorroBar.className='clc-ahorro puede';
    ahorroBar.innerHTML=`<span>Estás dejando ir <b>${pesos(r.ahorrable)}</b> en esta compra.</span>
      <button id="clcTodo">Suscribir todo</button>`;
  } else if(r.ahorrando>0){
    ahorroBar.hidden=false; ahorroBar.className='clc-ahorro gano';
    ahorroBar.innerHTML=`<span>Estás ahorrando <b>${pesos(r.ahorrando)}</b> con tu suscripción.</span>`;
  } else ahorroBar.hidden=true;

  cuerpo.innerHTML = r.n===0
    ? '<p class="clc-vacio">Todavía no hay nada aquí.<br>Empieza por los 400 ml.</p>'
    : r.items.map(lineaHTML).join('');

  const ex = r.n===0 ? '' : extrasHTML(c);
  extras.innerHTML=ex; extras.hidden=!ex;

  /* consentimiento: solo si hay al menos una linea recurrente */
  if(r.subs.length){
    const txt=consentTexto(r), firma=txt;
    consent.hidden=false;
    okTxt.innerHTML=txt.replace('Términos de la suscripción',
      `<a href="${TERMS}" target="_blank" rel="noopener">Términos de la suscripción</a>`);
    /* si cambia el monto o la frecuencia, el consentimiento anterior ya no
       corresponde al cargo que se va a hacer: se desmarca */
    if(okBox.dataset.firma && okBox.dataset.firma!==firma){ okBox.checked=false; guardaConstancia(''); }
    okBox.dataset.firma=firma;
    irPagar.disabled=!okBox.checked;
    irPagar.textContent=okBox.checked?'Ir a pagar':'Acepta para continuar';
  } else {
    consent.hidden=true; okBox.checked=false; delete okBox.dataset.firma;
    irPagar.disabled=r.n===0; irPagar.textContent='Ir a pagar';
  }

  /* doble salida: la segunda solo existe cuando hay algo que convertir */
  if(r.ahorrable>0 && !r.subs.length){
    irPagar.textContent='Suscribirme y ahorrar';
    irPagar.disabled=false;
    irPagar.dataset.accion='suscribir';
    alterna.hidden=false; alterna.textContent='Seguir con compra única';
  } else {
    delete irPagar.dataset.accion;
    alterna.hidden=true;
  }
}

async function suscribeTodo(){
  const r=calcula(ULTIMO);
  for(const x of r.items){
    if(!x.selling_plan_allocation && ELEGIBLES.has(x.handle)) await modalidad(x, PLAN_DEFAULT);
  }
  pinta(await carrito());
}

async function abre(abrir){
  cajon.classList.toggle('abierto',abrir); velo.classList.toggle('abierto',abrir);
  cajon.setAttribute('aria-hidden',String(!abrir));
  document.body.style.overflow=abrir?'hidden':'';   /* la clase no sirve: el CSS esta encerrado */
  const st=document.getElementById('sticky');
  if(abrir){ if(st) st.classList.remove('show'); pinta(await carrito()); }
}

if(boton) boton.addEventListener('click',()=>abre(true));
$('clcX').addEventListener('click',()=>abre(false));
$('clcSeguir').addEventListener('click',()=>abre(false));
velo.addEventListener('click',()=>abre(false));
addEventListener('keydown',e=>{if(e.key==='Escape')abre(false)});

/* cantidad y modalidad, delegados */
cuerpo.addEventListener('click',async e=>{
  const linea=e.target.closest('.clc-linea'); if(!linea) return;
  const dato=ULTIMO.items.find(x=>String(x.key)===linea.dataset.key);

  const b=e.target.closest('[data-mas]');
  if(b){
    const q=+linea.querySelector('.clc-qty span').textContent + (+b.dataset.mas);
    await cambia(linea.dataset.key, Math.max(0,q));
    return pinta(await carrito());
  }
  const m=e.target.closest('[data-modo]');
  if(m && dato){
    const quiere = m.dataset.modo==='sub';
    const tiene  = !!dato.selling_plan_allocation;
    if(quiere===tiene) return;
    m.closest('.clc-modo').classList.add('cargando');
    await modalidad(dato, quiere?PLAN_DEFAULT:null);
    return pinta(await carrito());
  }
});
cuerpo.addEventListener('change',async e=>{
  const sel=e.target.closest('.clc-frec'); if(!sel) return;
  const linea=sel.closest('.clc-linea');
  const dato=ULTIMO.items.find(x=>String(x.key)===linea.dataset.key);
  if(!dato) return;
  await modalidad(dato, sel.value);
  pinta(await carrito());
});

ahorroBar.addEventListener('click',e=>{ if(e.target.id==='clcTodo') suscribeTodo(); });

extras.addEventListener('click',async e=>{
  const b=e.target.closest('.clc-extra'); if(!b) return;
  b.classList.add('cargando');
  await agrega(b.dataset.sku,null,null);
  pinta(await carrito());
});

okBox.addEventListener('change',async()=>{
  /* el boton responde de INMEDIATO. Las dos llamadas de red que siguen tardan
     como 2 segundos, y un boton que despues de aceptar sigue diciendo 'Acepta
     para continuar' se lee como que no funciono: el cliente le vuelve a picar
     a la casilla y la desmarca. Primero la UI, luego la persistencia. */
  irPagar.disabled=!okBox.checked;
  irPagar.textContent=okBox.checked?'Ir a pagar':'Acepta para continuar';
  await guardaConstancia(okBox.checked?consentTexto(calcula(ULTIMO)):'');
  pinta(await carrito());
});

irPagar.addEventListener('click',async()=>{
  if(irPagar.dataset.accion==='suscribir') return suscribeTodo();
  if(irPagar.disabled) return;
  location.href='/checkout';
});
alterna.addEventListener('click',()=>{ location.href='/checkout'; });

/* ---- barra ----
   Vive aqui y no en cada pagina: todas las plantillas del tema montan la misma
   barra y solo cargan este archivo. */
const barra=document.getElementById('clnav'), hamb=document.getElementById('clnavBurger');
if(barra){
  addEventListener('scroll',()=>barra.classList.toggle('solido',scrollY>40),{passive:true});
  if(scrollY>40) barra.classList.add('solido');
  if(hamb) hamb.addEventListener('click',()=>{
    const on=!barra.classList.contains('abierto');
    barra.classList.toggle('abierto',on); hamb.setAttribute('aria-expanded',String(on));
  });
  const links=document.getElementById('clnavLinks');
  if(links) links.addEventListener('click',()=>{
    barra.classList.remove('abierto'); if(hamb) hamb.setAttribute('aria-expanded','false');
  });
}

carrito().then(pinta);
window.CLCart={agrega, abre, refresca:async()=>pinta(await carrito()),
  /* para la pagina de producto, donde el id de variante ya se conoce */
  agregaVariante:async(id, qty, plan)=>{
    const linea={id:+id, quantity:qty||1}; if(plan) linea.selling_plan=+plan;
    const j=await pide('/cart/add.js',{items:[linea]});
    if(!j){ const k=String(id), hay=LOCAL.items.find(x=>x.key===k);
      if(hay) hay.quantity+=(qty||1);
      else LOCAL.items.push({key:k, quantity:qty||1, price:0, original_price:0,
        product_title:'Producto', handle:'cold-brew', variant_id:+id, image:''}); }
    return true;
  }};
})();
